<template>
  <div class="c-convincing-deactivating-list">
    <h6 class="title is-spaced">Que tal uma ajudinha nessa tarefa?</h6>
    <p class="subtitle">
      Conte com o nosso atendimento para te auxiliar em tudo que você precisa
      saber pra editar a sua lista de presentes:
    </p>

    <ul class="benefits-list">
      <li>
        <base-icon
          class="icon"
          width="24"
          height="24"
          name="painel/circle-bordered"
        />
        Como editar a lista de presentes;
      </li>
      <li>
        <base-icon
          class="icon"
          width="24"
          height="24"
          name="painel/circle-bordered"
        />
        Como criar presentes totalmente personalizados;
      </li>
      <li>
        <base-icon
          class="icon"
          width="24"
          height="24"
          name="painel/circle-bordered"
        />
        Como configurar taxas e conta para recebimento;
      </li>
      <li>
        <base-icon
          class="icon"
          width="24"
          height="24"
          name="painel/circle-bordered"
        />
        E muito mais!
      </li>
      <li>É só clicar no botão abaixo para falar com a gente ;)</li>
    </ul>

    <a
      @click="$emit('keepList')"
      href="https://casarpontocom.freshdesk.com/support/solutions/articles/73000559934"
      target="_blank"
      class="button is-primary"
    >
      Quero ajuda para criar a minha lista de presentes
    </a>
    <p>
      <a @click="$emit('disableList')" class="link" href="#">
        Quero desativar a minha lista de presentes
      </a>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },

  methods: {},
}
</script>
